import { Col, Nav, NavLink } from "reactstrap";
import { ContactListProps, UserCallback } from "../../../../../types/Applications";
import { dynamicImage } from "../../../../../utils";
import EmptyData from "../EmptyState";
import { Image } from "../../../../../coreComponents/Image";

// This component displays a list of users and allows selecting a user to view details.
const ContactList: React.FC<ContactListProps> = ({ users, userCallback, selectedUser }) => {

  const contactDetails = (user: UserCallback) => userCallback({ id: user.id, name: user.name, surname: user.surname, email: user.email, avatar: user.avatar, age: user.age, mobile: user.mobile });

  return (
    <Col xl="4" md="5" className="xl-50">
      <Nav className="flex-column" pills>
        {/* Mapping through users to display a dynamic list of users contact */}
        {users.length > 0 ? (
          users.map((user, index) => (
            <NavLink className={user.id === selectedUser.id ? "active" : ""} key={index} onClick={() => contactDetails(user)}>
              <div className="d-flex">
                <Image className="img-50 img-fluid m-r-20 rounded-circle" src={dynamicImage(user.avatar)} alt="" />
                <div className="flex-grow-1">
                  <h6 className="f-w-600">
                    <span className="f-w-600">{user.name}</span>
                    <span className="f-w-600">{user.surname}</span>
                  </h6>
                  <p>{user.email}</p>
                </div>
              </div>
            </NavLink>
          ))
        ) : (
          <EmptyData />
        )}
      </Nav>
    </Col>
  );
};
export default ContactList;